import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getPagesD = () => {
  try {
    const response = privateAxiosIntance.get(protectedRoutes.pageDesign);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPagesDById = (id) => {
  try {
    console.log("ids", id);
    const response = privateAxiosIntance.get(`${protectedRoutes.pageDesign}`, {
      params: id,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deletePagesD = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(
      `${protectedRoutes.pageDesign}`,
      { data: reqBody },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postPagesD = (reqBody) => {
  try {
    const response = privateAxiosIntance.post(
      protectedRoutes.pageDesign,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const patchPagesD = (reqBody) => {
  try {
    const response = privateAxiosIntance.patch(
      protectedRoutes.pageDesign,
      reqBody,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
